import { render, staticRenderFns } from "./asignaturas.vue?vue&type=template&id=f0a9b8ba"
import script from "./asignaturas.vue?vue&type=script&lang=js"
export * from "./asignaturas.vue?vue&type=script&lang=js"
import style0 from "./asignaturas.vue?vue&type=style&index=0&id=f0a9b8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports